import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "logo" }
const _hoisted_2 = { class: "login-container" }

import AuthManager, {AuthProvider} from "./AuthManager"
import { ref } from 'vue'
import type { Ref } from 'vue'
import '../../images/logo-sensus-sign-in.gif'

//const authError: string | null = ref(null)
const authError: string = null

type Providers = AuthProvider[];


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthScreen',
  props: {
    providers: {}
  },
  setup(__props: any) {

const props = __props

const { loginProviders, customer, login, getCustomerRealm } = useLogin()

function useLogin()
{
    const loginProviders:Ref<Providers> = ref(props.providers)
    const customer:Ref<string> = ref('')

    function login(provider: AuthProvider)
    {
        AuthManager.continueLogin(provider, null)
    }

    async function getCustomerRealm()
    {
        // lookupCustomerAuthority will run continueLogin if successful
        try {
            await AuthManager.lookupCustomerAuthority(customer.value)
        } catch (error) {
            this.authError = error
        }
    }

    return {
        loginProviders,
        customer,
        login,
        getCustomerRealm,
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    class: "background-base",
    view: "hHh lpR fFf"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_img, {
              src: "./assets/logo-sensus-sign-in.gif",
              alt: "Sensus",
              width: "200px",
              height: "80px"
            }),
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('auth.title')), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_text_field, {
              class: "q-mb-sm",
              modelValue: _unref(customer),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(customer) ? (customer).value = $event : null)),
              label: _ctx.$t('auth.customer'),
              error: authError != null,
              outlined: "",
              dense: "",
              onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_unref(getCustomerRealm)()), ["enter"]))
            }, null, 8 /* PROPS */, ["modelValue", "label", "error"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(authError)), 1 /* TEXT */),
            _createVNode(_component_v_btn, {
              class: "provider-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(getCustomerRealm)()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('auth.logIn')), 1 /* TEXT */)
              ], undefined, true),
              _: 1 /* STABLE */
            }),
            _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "q-my-lg" }, null, -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(loginProviders), (provider) => {
              return (_openBlock(), _createElementBlock("div", {
                key: provider.displayName
              }, [
                _createVNode(_component_v_btn, {
                  class: "provider-btn",
                  onClick: ($event: any) => (_unref(login)(provider))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(provider.displayName), 1 /* TEXT */)
                  ], undefined, true),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], undefined, true),
        _: 1 /* STABLE */
      })
    ], undefined, true),
    _: 1 /* STABLE */
  }))
}
}

})